import _ from 'lodash';
import { Box, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { ErrorIcon } from '../../theme/styled-components';

interface ErrorMessageProps {
  classes?: Record<string, string>;
  error?: {
    errors?: { message: string }[];
    message?: string;
  };
  icon?: string;
  width?: string;
}

function ErrorMessage({
  classes = {},
  error = {},
  width = '',
  icon = '',
}: ErrorMessageProps) {
  if (_.isEmpty(error)) return <span />;

  return (
    <Box
      className={`${classes.infoBox} width-${width}`}
      data-testid="error-message"
    >
      {icon.length > 0 && (
        <Box className={classes.infoBoxIcon}>
          {icon === 'error' && (
            <Box className={classes.errorIconContainer}>
              <ErrorIcon className={classes.errorIcon} />
            </Box>
          )}
        </Box>
      )}
      <Typography align="left" className={classes.infoBoxText} variant="body2">
        {_.isArray(error.errors) ? error.errors[0].message : error.message}
      </Typography>
    </Box>
  );
}

export default withStyles(styles)(ErrorMessage);
